








































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { TYPES, BOOKING_PURPOSES } from '@/constants/booking';
import ServiceOrderCreate from '@/pages/Business/ServiceOrder/ServiceOrderCreate.vue';
import ServiceOrderRead from '@/pages/Business/ServiceOrder/ServiceOrderRead.vue';
import BodyMapMixins from '@/mixins/BodyMapMixins';
import TransitionMixins from '@/mixins/TransitionMixins';
import BookingCreateCandidateTableItem from './BookingCreateCandidateTableItem.vue';
import { SERVICE_ITEMS } from '@/constants/service_request';

@Component({
  components: {
    ServiceOrderCreate,
    ServiceOrderRead,
    BookingCreateCandidateTableItem,
  },
  computed: {
    ...mapState('Auth', {
      business: 'activeBusiness',
      user: 'user',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('RiskProfile', {
      riskProfile: 'riskProfile',
      bodyParts: 'bodyParts', // is used in BodyMapMixins
    }),
    ...mapGetters('RiskProfile', {
      enabledQuestionGroups: 'enabledQuestionGroups',
      bodyPartPreviewItems: 'bodyPartPreviewItems',
    }),
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
    }),
  },
})
export default class BookingCreateFinalise extends Mixins(
  BodyMapMixins,
  TransitionMixins
) {
  booking!: Booking;
  business!: Model;
  riskProfile!: Model;
  bodyPartPreviewItems!: [];
  enabledQuestionGroups!: [];
  serviceItems!: Model[];

  types = TYPES;
  showAdditionalService = false;
  purposes = BOOKING_PURPOSES;
  currentPage = 1;
  itemsPerPage = 10;
  search = '';

  get headers() {
    const header = [
      { text: 'Candidate' },
      { text: 'Email', sortable: false },
      { text: 'Phone Number', sortable: false },
      { text: 'Department', sortable: false },
    ];

    if (this.showAdditionalService) {
      header.push({ text: 'Additional Services', sortable: false });
    }

    return header;
  }
  showPreview = false;
  questionGroupDescription =
    'Here is the list of the question groups the individual will complete which will provide the relevant information in their report.';

  get additionalServices() {
    return this.serviceItems
      .filter((serviceItem) => serviceItem.key !== 'assessment')
      .map((serviceItem) => {
        return {
          object_id: serviceItem.object_id,
          key: serviceItem.key,
          icon: SERVICE_ITEMS[serviceItem.key].icon,
          name: serviceItem.name,
        };
      });
  }

  get isGHC() {
    return !!this.booking.ghc_name;
  }

  calculateServiceQuantityBy(objectId) {
    return this.booking.booking_candidates?.filter((candidate) =>
      candidate.additional_services.includes(objectId)
    ).length;
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          'first_name',
          'last_name',
          'date_of_birth',
          'mobile',
          'email',
        ].includes(k) &&
        item[k]
          .toString()
          .toLowerCase()
          .includes(search)
      );
    });
  }
}
